import request from '@/utils/request'

let Government_introApi = {

  /*政府简介列表*/
  list(data) {
    return request._post('/shop/plus.government_intro.Index/index', data);
},
listx(data) {
    return request._post('/shop/plus.government_intro.Index/indexx', data);
},
/*添加政府简介*/
add(data) {
    return request._post('/shop/plus.government_intro.Index/add', data);
},
/*修改政府简介*/
edit(data) {
    return request._post('/shop/plus.government_intro.Index/edit', data);
},
/*删除政府简介*/
del(data) {
    return request._post('/shop/plus.government_intro.Index/del', data);
},
/*政府简介详情*/
detail(data) {
  return request._post('/shop/plus.government_intro.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.government_intro.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.government_intro.Setting/getSetting', data, errorback);
    },
}
export default Government_introApi;



// WEBPACK FOOTER //
// ./src/api/government_intro.js